import React from 'react';
import SettingsLanding from '../components/SettingsLanding';

const Settings = () => {
  return <SettingsLanding />;
};
export default Settings;
